import React, { useEffect, useMemo, useState } from "react";
import { Checkbox, Col, Row } from "antd";
import { DropdownSelect } from "../DropdownSelect";
import {
  createDefaultValueObject,
  isObject,
  localStorage,
  parseFormControlValue
} from "../../../services";
import { LocalStorageKey } from "../../../models";
import styles from "./styles.scss"
import { getIconUrl } from '../../../services/asset';
const Tyres = props => {
  const { onChange, children, field, title, value, data } = props;

  const defaultFieldValue = useMemo(() => createDefaultValueObject([field]), [field]);
  const defaultRowValue = useMemo(() => createDefaultValueObject(children.map(child => child.field)), [children]);

  const [checked, setChecked] = useState(false);
  const [rows, setRows] = useState([{}]);
  let currentData = localStorage.getItem(LocalStorageKey.savedForm);

  useEffect(() => {
    // If value exists on component mount
    if (value) {
      setChecked(true);
      let rowValues = [];

      // Loop through dimension value, map and set to rows state
      if (JSON.stringify(value) !== JSON.stringify({})) {
        Object.keys(value).forEach(key => {
          if (key != field) {

            // If value is not array put it into array, for legacy data
            if (!Array.isArray(value[key])) {
              value[key] = [value[key]];
            }

            value[key].forEach((item, index) => {
              if (!rowValues[index]) {
                rowValues[index] = {};
              }
              rowValues[index][key] = item || undefined;
            });
          }
        });
      }

      // If value does not have any dimension put blank row for input
      if (rowValues.length === 0) {
        rowValues[0] = defaultRowValue
      }

      // Set rows to state
      setRows(rowValues);
    }
  }, []);

 const afterRowChange = (values) => {
  // On state change, merge all rows into one object and call onChange
    const merged = values.length ? values.reduce((acc, cur) => {
      for (const key in cur) {
        if (Object.prototype.hasOwnProperty.call(cur, key)) {
          acc[key] = acc[key] || [];
          acc[key].push(cur[key]);
        }
      }

      return acc;
    }, {}) : defaultRowValue;

    // Add field to merged object
    if (checked) merged[field] = true;

    // Call onChange
    setRows(values);
    props.onChange(merged);
 }

  const getValue = () => {
    const { value } = props;
    const values = [];

    isObject(value) &&
      Object.keys(value).forEach(property => {
        if (property == field) {
          if (value[property]) {
            values.push(property);
          }
        }
      });
 
    return values;
  };

  const handleFieldChange = values => {
    setChecked(true);
    const parsedValue = parseFormControlValue(
      values,
      Array(values.length).fill(true)
    );


    let keys = [];

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        keys.push(key);
      }
    }

    if (JSON.stringify(values) == JSON.stringify([])) {
      setChecked(false);

      keys.forEach(key => {
        if (key != field) {
          delete currentData[key];
          afterRowChange([{}]);
        }
      });

      localStorage.setItem(LocalStorageKey.savedForm, currentData);
    }

    onChange({ ...defaultFieldValue, ...parsedValue });
  };

  // Add row object with dimension values to rows array in state
  const addRow = () => {
    afterRowChange([...rows, defaultRowValue]);
  }

  // Remove specific row object with dimension values from rows array in state
  const removeRow = (index) => {
    const newArray = [...rows];
    newArray.splice(index, 1);
    afterRowChange(newArray);
  }

  // On dropdown change put dimension values into row state prop array with specific index 
  const onValueChange = (value, rowIndex) => {
    afterRowChange(rows.map((row, index) => index === rowIndex ? { ...defaultRowValue, ...value } : row));
  }

  return (
    <div >
      <Checkbox.Group
        style={{ width: "100%", margin: "10px 0 10px" }}
        value={getValue()}
        onChange={handleFieldChange}
      >
        <Checkbox value={field}>{title}</Checkbox>
      </Checkbox.Group>
      {checked && rows.map((row, rowIndex) => (
        <Row className={styles.row} gutter={8} type="flex" key={rowIndex}>
          {children.map((child, index) => (
            <Col className={styles.col} key={index} md={8} xs={24}>
              <DropdownSelect
                {...props}
                onChange={(value) => onValueChange(value, rowIndex)}
                field={child.field}
                type={child.type}
                title={child.title}
                options={child.options}
                isDisabled={!checked}
                key={index}
                value={{ ...row }}
                tyres
              />
            </Col>
          ))}

          {checked && <span
            onClick={() => removeRow(rowIndex)}
            className={styles.removeRow}
          >
            <img
              alt={"Više"}
              src={getIconUrl("garbage.svg")}
            />
          </span>}
           
        </Row>
      ))}
      {(checked && rows.length < 5) && (
        <Col
          onClick={addRow}
          xs={24}
          className={styles.addRow}
        >
          <img
            alt={"Dodajte dimenziju"}
            src={getIconUrl("circled-plus-red.svg")}
          />
          <span>{"Dodajte dimenziju"}</span>
        </Col>
      )}

    </div>
  );
};

export default Tyres;



// WEBPACK FOOTER //
// ./src/components/FormControls/Tyres/Tyres.tsx